import { NavLink, Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getAdminToken } from '../lib/admin-api';
import { clearUserSession, getUserSession, type AuthenticatedUser } from '../lib/user-auth';

const NAV = [
  { to: '/', label: 'Tableau de bord', exact: true },
  { to: '/companies', label: 'Dossiers' },
  { to: '/runs', label: 'Historique' },
];

export function Layout() {
  const [hasAdminToken, setHasAdminToken] = useState(false);
  const [user, setUser] = useState<AuthenticatedUser | null>(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setHasAdminToken(getAdminToken() !== null);
    setUser(getUserSession());
  }, [location.pathname]);

  function logout() {
    clearUserSession();
    navigate('/login', { replace: true });
  }

  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <header className="bg-ink text-cream border-b border-gold/20">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-8 flex-wrap">
            <Link to="/" className="font-serif text-2xl font-bold">
              Mizan<span className="text-gold">™</span>
            </Link>
            <nav className="flex flex-wrap gap-x-5 gap-y-1 text-sm">
              {NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.exact}
                  className={({ isActive }) =>
                    isActive ? 'text-gold border-b-2 border-gold pb-1' : 'opacity-80 hover:opacity-100'
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3 text-xs">
            {user && (
              <div className="flex items-center gap-2">
                <div className="text-right leading-tight">
                  <div className="font-medium">{user.full_name}</div>
                  <div className="opacity-60 capitalize">{user.role}</div>
                </div>
                <button
                  type="button"
                  onClick={logout}
                  className="px-2 py-1 rounded border border-cream/30 text-cream/80 hover:bg-cream/10 transition"
                  title="Déconnexion"
                >
                  ⏻
                </button>
              </div>
            )}
            {hasAdminToken ? (
              <Link
                to="/admin/settings"
                className="px-2 py-1 rounded border border-gold text-gold hover:bg-gold hover:text-ink transition"
              >
                ⚙ Admin
              </Link>
            ) : (
              <Link
                to="/admin/login"
                className="opacity-50 hover:opacity-100 transition"
                title="Espace super-admin"
              >
                ⚙
              </Link>
            )}
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-7xl mx-auto w-full px-6 py-8">
        <Outlet />
      </main>
      <footer className="border-t border-border py-4 text-center text-xs text-taupe">
        © 2026 DevFactory · Mizan Platform · {user ? user.firm_id : 'mode dev'}
      </footer>
    </div>
  );
}
